<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="当天日期">
<!--                  <el-input  v-model="queryForm.dayDate"></el-input>-->
                  <el-date-picker
                      style="width: 177px;"
                      size="small"
                      v-model="queryForm.dayDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getOperationSubsidyInactiveScoreList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addOperationSubsidyInactiveScore"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editOperationSubsidyInactiveScore(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteOperationSubsidyInactiveScore(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshOperationSubsidyInactiveScoreList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="operationSubsidyInactiveScoreList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendMoney"
        label="我收到抵扣券数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="总发放抵扣券数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentScore"
        label="我拥有积分数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalScore"
        label="总积分数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payMoney"
        label="消费或收款金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="serviceMoney"
        label="服务费金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="activeValue"
        label="活跃值"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkOperationSubsidyInactiveScore(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editOperationSubsidyInactiveScore(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteOperationSubsidyInactiveScore(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="operationSubsidyInactiveScoreStates[operationSubsidyInactiveScoreState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="operationSubsidyInactiveScore"
          ref="operationSubsidyInactiveScoreForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationSubsidyInactiveScore.userId"-->
<!--              :disabled="operationSubsidyInactiveScoreState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="operationSubsidyInactiveScoreState == 'check'"
                           labelValue="id" title="选择用户" :value="operationSubsidyInactiveScore.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="operationSubsidyInactiveScore.dayDate"-->
<!--              :disabled="operationSubsidyInactiveScoreState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style="width: 177px;"
                  size="small"
                  v-model="operationSubsidyInactiveScore.dayDate"
                  :disabled="operationSubsidyInactiveScoreState == 'check'"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="我收到抵扣券数量"
            prop="sendMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.sendMoney"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总发放抵扣券数量"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.totalMoney"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="我拥有积分数量"
            prop="currentScore"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.currentScore"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总积分数量"
            prop="totalScore"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.totalScore"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="消费或收款金额"
            prop="payMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.payMoney"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="服务费金额"
            prop="serviceMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.serviceMoney"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="活跃值"
            prop="activeValue"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="operationSubsidyInactiveScore.activeValue"
              :disabled="operationSubsidyInactiveScoreState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="operationSubsidyInactiveScoreState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetOperationSubsidyInactiveScoreList();
                    this.getOperationSubsidyInactiveScoreList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetOperationSubsidyInactiveScoreList();
                    this.getOperationSubsidyInactiveScoreList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     userId: '', //用户
                     dayDate: '', //当天日期
                     sendMoney: '', //我收到抵扣券数量
                     totalMoney: '', //总发放抵扣券数量
                     currentScore: '', //我拥有积分数量
                     totalScore: '', //总积分数量
                     payMoney: '', //消费或收款金额
                     serviceMoney: '', //服务费金额
                     activeValue: '', //活跃值
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                operationSubsidyInactiveScoreState: 'add',
                operationSubsidyInactiveScoreStates: {
                    add: '新建贡献值不活跃',
                    check: '查看贡献值不活跃',
                    edit: '修改贡献值不活跃'
                },

                multipleSelection: [],
                operationSubsidyInactiveScoreList: [],
                operationSubsidyInactiveScore: {
                    id: '', //ID
                    userId: '', //用户
                    dayDate: '', //当天日期
                    sendMoney: '', //我收到抵扣券数量
                    totalMoney: '', //总发放抵扣券数量
                    currentScore: '', //我拥有积分数量
                    totalScore: '', //总积分数量
                    payMoney: '', //消费或收款金额
                    serviceMoney: '', //服务费金额
                    activeValue: '', //活跃值
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    sendMoney: [{ required: true, message: '我收到抵扣券数量不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '总发放抵扣券数量不能为空', trigger: 'blur' }],
                    currentScore: [{ required: true, message: '我拥有积分数量不能为空', trigger: 'blur' }],
                    totalScore: [{ required: true, message: '总积分数量不能为空', trigger: 'blur' }],
                    payMoney: [{ required: true, message: '消费或收款金额不能为空', trigger: 'blur' }],
                    serviceMoney: [{ required: true, message: '服务费金额不能为空', trigger: 'blur' }],
                    activeValue: [{ required: true, message: '活跃值不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getOperationSubsidyInactiveScoreList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value){
                this.operationSubsidyInactiveScore.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetOperationSubsidyInactiveScoreList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.operationSubsidyInactiveScoreList = [];
            },
            resetDialog() {
                this.operationSubsidyInactiveScoreState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      userId: '', //用户
                      dayDate: '', //当天日期
                      sendMoney: '', //我收到抵扣券数量
                      totalMoney: '', //总发放抵扣券数量
                      currentScore: '', //我拥有积分数量
                      totalScore: '', //总积分数量
                      payMoney: '', //消费或收款金额
                      serviceMoney: '', //服务费金额
                      activeValue: '', //活跃值
                };
                this.getOperationSubsidyInactiveScoreList();
            },
            closeDialog() {
                this.showDialog = false
                this.operationSubsidyInactiveScore = {
                      id: '', //ID
                      userId: '', //用户
                      dayDate: '', //当天日期
                      sendMoney: '', //我收到抵扣券数量
                      totalMoney: '', //总发放抵扣券数量
                      currentScore: '', //我拥有积分数量
                      totalScore: '', //总积分数量
                      payMoney: '', //消费或收款金额
                      serviceMoney: '', //服务费金额
                      activeValue: '', //活跃值
                };
            },
            submitForm() {
                if (this.operationSubsidyInactiveScoreState == 'add') {
                    this.$refs.operationSubsidyInactiveScoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/operation/subsidyinactivescore/add`,{ ...this.operationSubsidyInactiveScore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetOperationSubsidyInactiveScoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.operationSubsidyInactiveScoreState == 'edit') {
                    this.$refs.operationSubsidyInactiveScoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.operationSubsidyInactiveScore.user;
                            post(`/operation/subsidyinactivescore/edit`,{ ...this.operationSubsidyInactiveScore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetOperationSubsidyInactiveScoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addOperationSubsidyInactiveScore() {
                this.showDialog = true;
                this.operationSubsidyInactiveScoreState = 'add';
            },
            checkOperationSubsidyInactiveScore(operationSubsidyInactiveScoreId) {
                console.log(operationSubsidyInactiveScoreId);
                this.currentOperationSubsidyInactiveScoreId = operationSubsidyInactiveScoreId;

                this.getOperationSubsidyInactiveScoreById();
                this.showDialog = true;
                this.operationSubsidyInactiveScoreState = 'check';
            },
            editOperationSubsidyInactiveScore(operationSubsidyInactiveScoreId) {
                console.log('operationSubsidyInactiveScore', operationSubsidyInactiveScoreId);
                if (operationSubsidyInactiveScoreId) {
                    this.currentOperationSubsidyInactiveScoreId = operationSubsidyInactiveScoreId;
                    this.getOperationSubsidyInactiveScoreById();
                } else {
                    this.operationSubsidyInactiveScore = { ...this.operationSubsidyInactiveScore, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.operationSubsidyInactiveScoreState = 'edit';
            },
            deleteOperationSubsidyInactiveScore(operationSubsidyInactiveScoreId) {
                let ids = '';
                if (operationSubsidyInactiveScoreId) {
                    ids = operationSubsidyInactiveScoreId;
                } else {
                    ids = this.multipleSelection.map((operationSubsidyInactiveScore) => operationSubsidyInactiveScore.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/operation/subsidyinactivescore/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetOperationSubsidyInactiveScoreList();
                                this.getOperationSubsidyInactiveScoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshOperationSubsidyInactiveScoreList() {
                this.resetOperationSubsidyInactiveScoreList();
                this.getOperationSubsidyInactiveScoreList();
            },
            getOperationSubsidyInactiveScoreList(query = {}) {
                this.loading = true;
                get(`/operation/subsidyinactivescore/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.operationSubsidyInactiveScoreList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getOperationSubsidyInactiveScoreById() {
                get(`/operation/subsidyinactivescore/get`,{ id: this.currentOperationSubsidyInactiveScoreId }).then((res) =>{
                    if(res.success){
                      this.operationSubsidyInactiveScore = { ...this.operationSubsidyInactiveScore, ...res.operationSubsidyInactiveScore };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportOperationSubsidyInactiveScoreList() {
                //this.btnLoading = true;
                exprotExcel(`/operation/subsidyinactivescore/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/operation/subsidyinactivescore/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/operation/subsidyinactivescore/importData`,formData);
              this.refreshOperationSubsidyInactiveScoreList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getOperationSubsidyInactiveScoreList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getOperationSubsidyInactiveScoreList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>